import React from 'react';
import { motion } from 'framer-motion';

const PageHeader = ({ eyebrow, title, subtitle }) => (
  <header className="page-header">
    <motion.div
      className="container"
      initial={{ y: 16 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </motion.div>
  </header>
);

export default PageHeader;
